/* eslint-disable no-console */

import type { ILogger } from 'oidc-client-ts';

export class AuthLogger implements ILogger {
    private static instance: AuthLogger;

    private constructor() {}

    static getInstance() {
        if (!AuthLogger.instance) {
            AuthLogger.instance = new AuthLogger();
        }

        return AuthLogger.instance;
    }

    error(message?: any, ...optionalParams: any[]): void {
        console.error(message, ...optionalParams);
    }

    info(message?: any, ...optionalParams: any[]): void {
        console.log(message, ...optionalParams);
    }

    debug(message?: any, ...optionalParams: any[]): void {
        console.log(message, ...optionalParams);
    }

    warn(message?: any, ...optionalParams: any[]): void {
        console.warn(message, ...optionalParams);
    }
}
